import { useTranslation } from 'react-i18next';

import { usePlot } from '@/pages/shared/hooks/usePlot';

export const usePlotLocation = ({ plotId }: { plotId?: string }) => {
  const { t } = useTranslation();

  const plot = usePlot(plotId).data;

  const plotCountry = plot?.address?.split(',')?.pop()?.trim();

  return plotCountry || t('global.plot.mapPopup.unknownLocation');
};
